import { PlayIcon } from 'lucide-react'
import { useCallback, useContext, useState } from 'react'

import EmployerContext from 'components/context/EmployerContext'
import { CollapsibleDataContainer } from 'components/reusable/CollapsibleDataContainer'
import { Banner, TextLink } from 'slab'

import EmployerComplianceCheckSheet from './EmployerComplianceCheckSheet'
import EmployerComplianceChecksTable from './EmployerComplianceChecksTable'

const Heading = ({ onStartCheckClick }: { onStartCheckClick: () => void }) => (
  <div className='flex items-center justify-between'>
    <div className='flex items-center space-x-2'>
      <span className='heading-md'>Checks</span>
      <div className='cursor-pointer' onClick={(e) => e.stopPropagation()}>
        <TextLink color='purple' leftIcon={PlayIcon} onClick={onStartCheckClick}>
          Start Check
        </TextLink>
      </div>
    </div>
  </div>
)

const EmployerChecksView = () => {
  const { employer, profile } = useContext(EmployerContext)
  const [isSheetOpen, setIsSheetOpen] = useState(false)

  const handleStartCheckClick = useCallback(() => {
    setIsSheetOpen(true)
  }, [])

  const successContent = (
    <div className='p-2'>
      <div className='mt-4 mb-4 p-3 bg-gray-50 rounded-md border border-gray-200'>
        <span className='font-bold text-md'>🙋 What is this?</span>
        <br />
        <span>
          These are automated checks run using our compliance partner, Footprint. These include KYB checks against the Employer and KYC checks against the Employer's Owners.
        </span>
      </div>
      <EmployerComplianceChecksTable employerId={employer!.id} />
      <EmployerComplianceCheckSheet
        isOpen={isSheetOpen}
        setIsOpen={setIsSheetOpen}
        employerId={employer!.id}
        employerProfile={profile!}
      />
    </div>
  )

  const errorContent = (
    <Banner title='Error loading compliance checks. Please try again later.' />
  )

  return (
    <CollapsibleDataContainer
      heading={
        <Heading onStartCheckClick={handleStartCheckClick} />
      }
      isLoading={false}
      error={false}
      localStorageKey='employer-checks-view'
      loadingContent={<div>Loading compliance checks...</div>}
      errorContent={errorContent}
      successContent={successContent}
    />
  )
}

export default EmployerChecksView
